import script from "./UploadSpvForm.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadSpvForm.vue?vue&type=script&setup=true&lang=js"

import "./UploadSpvForm.vue?vue&type=style&index=0&id=5944cae4&lang=scss"

const __exports__ = script;

export default __exports__